export const STORAGE_ROUTE_KEY = 'route';
export const DEV_API_ENVIRONMENT = 'devApiEnvironment';
export const EXTERNAL_HOMEPAGE_ENABLED_LOCALLY =
  'externalHomepageEnabledLocally';
export const CURRENCY_STORAGE_KEY = 'selected_currency';
export const DISCOUNT_CODE_STORAGE_KEY = 'discount';
